const form13 = {
  formId13: "new-user-form13",
  formField13: {
    totalTaxTNDN: {
      name: "totalTaxTNDN",
      label: "[04] Tổng số thuế TNDN phải nộp được phân bố (đồng):",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tổng số thuế TNDN phải nộp được phân bố (đồng)",
    },
    totalExpense: {
      name: "totalExpense",
      label: "[05] Tổng chi phí được phân bố (đồng):",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tổng chi phí được phân bố (đồng)",
    },
  },
};

export default form13;
